if (!customElements.get('cart-footer')) {
class CartFooter extends HTMLElement {
  constructor() {
    super();
    this.requireTerms = this.dataset.requireTerms === 'true';
  }

  connectedCallback() {
    this.boundHandleTermsChange = this.handleTermsChange.bind(this);
    this.boundHandleDelegatedClick = this.handleDelegatedClick.bind(this);
    this.refreshRefs();
    this.attachEvents();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundHandleDelegatedClick);
    this.termsCheckbox?.removeEventListener('change', this.boundHandleTermsChange);
  }

  refreshRefs() {
    this.termsCheckbox = this.querySelector('[data-cart-terms]');
    this.checkoutButton = this.querySelector('[data-action="checkout"]');
    this.clearButton = this.querySelector('[data-action="clear-cart"]');
  }

  attachEvents() {
    this.addEventListener('click', this.boundHandleDelegatedClick);
    this.termsCheckbox?.addEventListener('change', this.boundHandleTermsChange);
  }

  handleDelegatedClick(event) {
    const actionTarget = event.target.closest('[data-action]');
    if (!actionTarget || !this.contains(actionTarget)) return;
    const action = actionTarget.dataset.action;
    if (action === 'checkout') {
      this.handleCheckout(event);
    } else if (action === 'clear-cart') {
      this.handleClearCart(event);
    }
  }

  handleTermsChange() {
    if (!this.shouldValidateTerms()) return;

    this.checkoutButton.disabled = !this.termsCheckbox.checked;
  }

  shouldValidateTerms() {
    return this.requireTerms && this.termsCheckbox && this.checkoutButton;
  }

  handleCheckout(event) {
    this.refreshRefs();
    if (this.shouldBlockCheckout()) {
      event.preventDefault();
      return;
    }

    window.location.href = `${window.Shopify.routes.root}checkout`;
  }

  shouldBlockCheckout() {
    return this.requireTerms && this.termsCheckbox && !this.termsCheckbox.checked;
  }

  async handleClearCart(event) {
    event.preventDefault();

    if (!this.confirmClearCart()) return;

    this.setLoading(true);

    try {
      const cart = await this.clearCart();
      theme.pubsub.publish(theme.pubsub.events.CART_UPDATE, { cart });
    } catch (error) {
      console.error('Error clearing cart:', error);
      this.setLoading(false);
      theme.pubsub.publish(theme.pubsub.events.CART_ERROR, { error });
    }
  }

  confirmClearCart() {
    const message = this.dataset.clearConfirm || 'Are you sure you want to clear your cart?';
    return confirm(message);
  }

  async clearCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }

  setLoading(isLoading) {
    const buttons = this.querySelectorAll('button');

    buttons.forEach((button) => {
      button.disabled = isLoading;
    });

    this.style.opacity = isLoading ? '0.6' : '1';
    this.style.pointerEvents = isLoading ? 'none' : '';
  }
}

customElements.define('cart-footer', CartFooter);
}
